<template>
  <div>
    <div>
      <img id="topbg" src="../assets/top_bg.png" />
      <div id="topleft">
        <img id="icon" :src="app.icon" />
        <div class="kaixin">
          <div id="kaixin_title">{{app.name}}</div>
        </div>
        <div class="noti">
          <font>连续打卡全额返 就在{{app.name}}</font>
        </div>
        <div class="btnP" @click="jump()">
          <img class="btnImg" src="~@/assets/apple.png" />
          <font class="btnFont">iOS系统下载</font>
        </div>
        <div class="btnP" @click="download()" style="margin-top: 20px">
          <img class="btnImg" src="~@/assets/bot.png" />
          <font class="btnFont">Android系统下载</font>
        </div>
      </div>
      <img id="shouji" src="~@/assets/shouji.png" />
    </div>
    <div class="word-wrap">
      <div class="bottom1">
        <div class="WordP">
          <h1>打卡简单 全额返购自主提现</h1>
          <div>只要坚持完成连续打卡任务 即全额返现</div>
          <p>• 进入指定京东或天猫店铺购买想要的指定商品</p>
          <p>• 进入{{app.name}}注册账号，关联商品</p>
          <p>• 每日打卡，完成阶段任务自主提现，直至全额</p>
        </div>
        <img class="imgs" src="~@/assets/right_top.png" />
      </div>
      <div class="bottom2">
        <img class="imgs" style="height:490px;margin-right:50px" src="~@/assets/left_bottom.png" />
        <div class="WordP">
          <h1>提现便捷 拒绝意外翻车</h1>
          <div>分阶段返现，完成阶段任务即可直接提现</div>
          <p>• 在{{app.name}}打卡至阶段任务完成</p>
          <p>• 进入领奖处，填写收款账户直接申请提现</p>
          <p>• 全部现金到账，更有神秘福利免费领取</p>
        </div>
      </div>
    </div>
  </div>
</template>
<!--(1920 px 1082 px)-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<script>
var downUrl = "https://s3.cn-northwest-1.amazonaws.com.cn/s3.jianos.com/Zero.apk";
const app = {
  icon: require('../assets/icon2.png'),
  name: '漫步今日益行'
}
export default {
  name: "Home",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      app
    };
  },
  created() {
    document.title = app.name
  },
  mounted() {
    function requestApi() {
      const url = "https://apifreego.jianos.com/app_update";
      const xhr = new XMLHttpRequest();
      xhr.open("get", url, true);
      xhr.setRequestHeader("content-type", "application/json");

      xhr.onload = () => {
        // console.log("xhr.response = ", xhr.response);
        if (xhr.status == 200) {
          const result = JSON.parse(xhr.response);
          // console.log(222, result);
          if (result && result.data && result.data.src) {
            downUrl = result.data.src;
            //if(callback)callback(result.src);
            // console.log("得到的下载地址是 = " + downUrl);
          }
        }
      };
      xhr.onerror = () => {
        // console.log("xhr.onerror = ", xhr);
      };
      xhr.send();
    }

    requestApi();
  },
  methods: {
    jump() {
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (isMac) {
        window.location.href = "itms-apps://itunes.apple.com/app/id1531655695";
        return;
      }
      alert("请在iOS手机safari浏览器中打卡此页面!");
    },
    download() {
      // console.log("点击下载按钮了");
      window.open(downUrl, "_blank");
    }
  }
};

</script>
<style scoped>
#topbg {
  width: 100%;
  height: 100%;
}

#topleft {
  width: 1200px;
  left: 9%;
  top: 50px;
  position: absolute;
  text-align: left;
}

#icon {
  width: 100px;
  height: 100px;
  border-radius: 20px;
}

.kaixin {
  position: relative;
  display: table;
}

#kaixin_title {
  color: #333333;
  font-size: 40px;
  font-weight: bold;
  height: 25px;
  background: #e94f35;
  line-height: 0px;
}

.noti {
  color: #e94f35;
  font-weight: bold;
  font-size: 20px;
  position: relative;
  white-space: nowrap;
  top: 20px;
}

.btnP {
  width: 350px;
  height: 60px;
  position: relative;
  margin-top: 57px;
  border-radius: 33px;
  background-color: #fb4644;
}

.btnP:active {
  top: 5px;
  /**向下偏移2px **/
}

.btnImg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 40px;
}

.btnFont {
  color: white;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 40px;
  /*left: auto;*/
}

.btnFont:active {
  font-size: 26px;
}

#shouji {
  width: 430px;
  height: 400px;
  right: 15%;
  top: 110px;
  position: absolute;
}

.word-wrap {
  width: 100%;
}

.bottom1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  width: 100%;
}

.bottom2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  width: 100%;
}

.WordP {
  text-align: left;
  margin: auto 0;
}

.WordP h1 {
  width: 500px;
  font-size: 30px;
}

.WordP div {
  width: 500px;
  font-size: 20px;
  margin: 10px 0;
}

.WordP p {
  width: 500px;
  font-size: 16px;
}

.imgs {
  width: 600px;
  height: 340px;
}

</style>
